import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { HelmetProvider } from 'react-helmet-async';

import SmoothScroll from '@/components/Layout/SmoothScroll';
import Header from '@/components/Layout/Header';
import Footer from '@/components/Layout/Footer';
import FloatingContacts from '@/components/Layout/FloatingContacts';
import { AuthProvider } from '@/contexts/AuthContext';

import HomePage from '@/pages/HomePage';
import TourPage from '@/pages/TourPage';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import NotFoundPage from '@/pages/NotFoundPage';

function PublicShell({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <FloatingContacts />
    </>
  );
}

function ScrollHashListener() {
  const loc = useLocation();
  useEffect(() => {
    if (loc.hash) {
      const id = loc.hash.replace('#', '');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [loc.pathname, loc.hash]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App grain relative">
        <Toaster position="bottom-right" theme="dark" richColors />
        <BrowserRouter>
          <AuthProvider>
            <ScrollHashListener />
            <SmoothScroll>
              <Routes>
                <Route path="/" element={<PublicShell><HomePage /></PublicShell>} />
                <Route path="/tour/:slug" element={<PublicShell><TourPage /></PublicShell>} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="*" element={<PublicShell><NotFoundPage /></PublicShell>} />
              </Routes>
            </SmoothScroll>
          </AuthProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
